/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeCompanyMemberPasswordBody,
  CompanyMembershipQueryResponse,
  GetCompanyMembershipsByCompanyParams,
  GetCompanyMembershipsParams,
  InviteCompanyMembershipBody,
  ResendPendingCompanyMembershipInvitesResponse,
  UpdateCompanyMembershipBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCompanyMemberships = (
    params: GetCompanyMembershipsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyMembershipQueryResponse>(
      {url: `/api/v1/company/memberships`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompanyMembershipsQueryKey = (params: GetCompanyMembershipsParams,) => {
    return [`/api/v1/company/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyMembershipsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMemberships>>, GetCompanyMembershipsParams['page']>, TError = ErrorType<unknown>>(params: GetCompanyMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']> = ({ signal, pageParam }) => getCompanyMemberships({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMemberships>>>
export type GetCompanyMembershipsInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMemberships>>, GetCompanyMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMemberships>>, GetCompanyMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMemberships>>, GetCompanyMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMemberships>>, GetCompanyMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData, Awaited<ReturnType<typeof getCompanyMemberships>>, QueryKey, GetCompanyMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(params: GetCompanyMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMemberships>>> = ({ signal }) => getCompanyMemberships(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMemberships>>>
export type GetCompanyMembershipsQueryError = ErrorType<unknown>


export function useGetCompanyMemberships<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMemberships<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMemberships>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMemberships<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMemberships<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyMembershipsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(params: GetCompanyMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMemberships>>> = ({ signal }) => getCompanyMemberships(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMemberships>>>
export type GetCompanyMembershipsSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyMembershipsSuspense<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsSuspense<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsSuspense<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMembershipsSuspense<TData = Awaited<ReturnType<typeof getCompanyMemberships>>, TError = ErrorType<unknown>>(
 params: GetCompanyMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyMembershipsByCompany = (
    companyId: number,
    params: GetCompanyMembershipsByCompanyParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyMembershipQueryResponse>(
      {url: `/api/v1/companies/${companyId}/memberships`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompanyMembershipsByCompanyQueryKey = (companyId: number,
    params: GetCompanyMembershipsByCompanyParams,) => {
    return [`/api/v1/companies/${companyId}/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyMembershipsByCompanyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, GetCompanyMembershipsByCompanyParams['page']>, TError = ErrorType<unknown>>(companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsByCompanyQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']> = ({ signal, pageParam }) => getCompanyMembershipsByCompany(companyId,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsByCompanyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>>
export type GetCompanyMembershipsByCompanyInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyMembershipsByCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, GetCompanyMembershipsByCompanyParams['page']>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, GetCompanyMembershipsByCompanyParams['page']>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, GetCompanyMembershipsByCompanyParams['page']>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMembershipsByCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, GetCompanyMembershipsByCompanyParams['page']>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData, Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, QueryKey, GetCompanyMembershipsByCompanyParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsByCompanyInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyMembershipsByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsByCompanyQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>> = ({ signal }) => getCompanyMembershipsByCompany(companyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>>
export type GetCompanyMembershipsByCompanyQueryError = ErrorType<unknown>


export function useGetCompanyMembershipsByCompany<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompany<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompany<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMembershipsByCompany<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsByCompanyQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyMembershipsByCompanySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyMembershipsByCompanyQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>> = ({ signal }) => getCompanyMembershipsByCompany(companyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyMembershipsByCompanySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>>
export type GetCompanyMembershipsByCompanySuspenseQueryError = ErrorType<unknown>


export function useGetCompanyMembershipsByCompanySuspense<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompanySuspense<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyMembershipsByCompanySuspense<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyMembershipsByCompanySuspense<TData = Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError = ErrorType<unknown>>(
 companyId: number,
    params: GetCompanyMembershipsByCompanyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyMembershipsByCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyMembershipsByCompanySuspenseQueryOptions(companyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const inviteCompanyMembership = (
    companyId: number,
    inviteCompanyMembershipBody: BodyType<InviteCompanyMembershipBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/companies/${companyId}/memberships/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteCompanyMembershipBody, signal
    },
      options);
    }
  


export const getInviteCompanyMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteCompanyMembership>>, TError,{companyId: number;data: BodyType<InviteCompanyMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteCompanyMembership>>, TError,{companyId: number;data: BodyType<InviteCompanyMembershipBody>}, TContext> => {
    
const mutationKey = ['inviteCompanyMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteCompanyMembership>>, {companyId: number;data: BodyType<InviteCompanyMembershipBody>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  inviteCompanyMembership(companyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteCompanyMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof inviteCompanyMembership>>>
    export type InviteCompanyMembershipMutationBody = BodyType<InviteCompanyMembershipBody>
    export type InviteCompanyMembershipMutationError = ErrorType<unknown>

    export const useInviteCompanyMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteCompanyMembership>>, TError,{companyId: number;data: BodyType<InviteCompanyMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof inviteCompanyMembership>>,
        TError,
        {companyId: number;data: BodyType<InviteCompanyMembershipBody>},
        TContext
      > => {

      const mutationOptions = getInviteCompanyMembershipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const resendPendingCompanyMembershipInvites = (
    companyId: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ResendPendingCompanyMembershipInvitesResponse>(
      {url: `/api/v1/companies/${companyId}/memberships/resend-invites/pending`, method: 'POST', signal
    },
      options);
    }
  


export const getResendPendingCompanyMembershipInvitesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>, TError,{companyId: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>, TError,{companyId: number}, TContext> => {
    
const mutationKey = ['resendPendingCompanyMembershipInvites'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>, {companyId: number}> = (props) => {
          const {companyId} = props ?? {};

          return  resendPendingCompanyMembershipInvites(companyId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendPendingCompanyMembershipInvitesMutationResult = NonNullable<Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>>
    
    export type ResendPendingCompanyMembershipInvitesMutationError = ErrorType<unknown>

    export const useResendPendingCompanyMembershipInvites = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>, TError,{companyId: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof resendPendingCompanyMembershipInvites>>,
        TError,
        {companyId: number},
        TContext
      > => {

      const mutationOptions = getResendPendingCompanyMembershipInvitesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateCompanyMembership = (
    companyId: number,
    userId: string,
    updateCompanyMembershipBody: BodyType<UpdateCompanyMembershipBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/companies/${companyId}/memberships/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyMembershipBody
    },
      options);
    }
  


export const getUpdateCompanyMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMembership>>, TError,{companyId: number;userId: string;data: BodyType<UpdateCompanyMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMembership>>, TError,{companyId: number;userId: string;data: BodyType<UpdateCompanyMembershipBody>}, TContext> => {
    
const mutationKey = ['updateCompanyMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyMembership>>, {companyId: number;userId: string;data: BodyType<UpdateCompanyMembershipBody>}> = (props) => {
          const {companyId,userId,data} = props ?? {};

          return  updateCompanyMembership(companyId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyMembership>>>
    export type UpdateCompanyMembershipMutationBody = BodyType<UpdateCompanyMembershipBody>
    export type UpdateCompanyMembershipMutationError = ErrorType<unknown>

    export const useUpdateCompanyMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyMembership>>, TError,{companyId: number;userId: string;data: BodyType<UpdateCompanyMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyMembership>>,
        TError,
        {companyId: number;userId: string;data: BodyType<UpdateCompanyMembershipBody>},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyMembershipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const changeCompanyMemberPassword = (
    companyId: number,
    userId: string,
    changeCompanyMemberPasswordBody: BodyType<ChangeCompanyMemberPasswordBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/companies/${companyId}/memberships/${userId}/change-password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeCompanyMemberPasswordBody
    },
      options);
    }
  


export const getChangeCompanyMemberPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCompanyMemberPassword>>, TError,{companyId: number;userId: string;data: BodyType<ChangeCompanyMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeCompanyMemberPassword>>, TError,{companyId: number;userId: string;data: BodyType<ChangeCompanyMemberPasswordBody>}, TContext> => {
    
const mutationKey = ['changeCompanyMemberPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeCompanyMemberPassword>>, {companyId: number;userId: string;data: BodyType<ChangeCompanyMemberPasswordBody>}> = (props) => {
          const {companyId,userId,data} = props ?? {};

          return  changeCompanyMemberPassword(companyId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeCompanyMemberPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeCompanyMemberPassword>>>
    export type ChangeCompanyMemberPasswordMutationBody = BodyType<ChangeCompanyMemberPasswordBody>
    export type ChangeCompanyMemberPasswordMutationError = ErrorType<unknown>

    export const useChangeCompanyMemberPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCompanyMemberPassword>>, TError,{companyId: number;userId: string;data: BodyType<ChangeCompanyMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeCompanyMemberPassword>>,
        TError,
        {companyId: number;userId: string;data: BodyType<ChangeCompanyMemberPasswordBody>},
        TContext
      > => {

      const mutationOptions = getChangeCompanyMemberPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    